
const digest = '9f94f3b04300973ca31a28e7936d74802a31db4722154622cf9c0246ccd955e1';
const classes = {"header":"_header_1ngib_1","normal":"_normal_1ngib_7"};
const css = `._header_1ngib_1 {
  color: rgb(6, 42, 96);
  font-weight: 600;
  font-size: 22px;
}

._normal_1ngib_7 {
  color: rgb(6, 42, 96);
  font-size: 16px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  